import {createApp} from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import locale from 'element-plus/lib/locale/lang/zh-cn';//中文
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import {getCarParkList, userPermit, autoDutyConfirmation} from "@/network/api";

const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
	app.component(key, component)
}
// 路由级钩子
router.beforeEach(async (to, from, next) => {
	const token = localStorage.getItem('token')
	if (to.path == '/login' && token) return next('/')
	if (to.path == '/login') return next()
	if (!token) return next('login');
	const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
	const {data} = await getCarParkList({uid: userInfo.id});
	store.commit("SETCARPARKLIST", data);
	if (!data[store.state.carParkIndex]) store.state.carParkIndex = 0;
	localStorage.setItem('parkId', data[store.state.carParkIndex].areaId);
	const res = await userPermit();
	localStorage.setItem("token", res.token.access_token);
	await autoDutyConfirmation({areaId: data[store.state.carParkIndex].areaId}).then(() => {
		store.commit("setDisableDuty", true);
	}).catch(() => {
		store.commit("setDisableDuty", false);
	});
	next();
});

app.use(router)
app.use(store)
app.use(ElementPlus, {locale}, {zIndex: 30000})

app.mount('#app')

